import { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { categoryMovieMap } from "@/mocks/movies";

export default function Category() {
  const { slug } = useParams<{ slug: string }>();
  const [activeSlug, setActiveSlug] = useState(slug || "movie");

  useEffect(() => {
    if (slug) {
      setActiveSlug(slug);
    }
  }, [slug]);

  const currentCat = categories.find((c) => c.slug === activeSlug);
  const movies = categoryMovieMap[activeSlug] || [];

  return (
    <>
      <header className="pt-20 pb-8 px-4 md:px-6 bg-background-100">
        <div className="max-w-7xl mx-auto">
          <nav className="flex items-center gap-2 text-xs text-foreground-500 mb-4 flex-wrap">
            <Link to="/" className="hover:text-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer">
              首页
            </Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-foreground-700 whitespace-nowrap">
              {currentCat?.name || "分类"}
            </span>
          </nav>
          <h1 className="font-heading text-xl md:text-2xl text-foreground-900 mb-2">
            {currentCat?.name || "分类"}
          </h1>
          <p className="text-sm text-foreground-500">
            {currentCat?.description || ""}
          </p>
        </div>
      </header>

      <section className="px-4 md:px-6 py-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center gap-2 mb-8 overflow-x-auto pb-2 flex-wrap">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 text-sm rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  activeSlug === cat.slug
                    ? "bg-primary-500 text-background-50"
                    : "bg-background-100 text-foreground-600 hover:bg-background-200"
                }`}
              >
                <span className="w-4 h-4 flex items-center justify-center inline-block mr-1.5">
                  <i className={`${cat.icon} text-xs`}></i>
                </span>
                {cat.name}
              </Link>
            ))}
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-5">
            {movies.map((movie) => (
              <Link
                key={movie.id}
                to={`/article/${movie.id}`}
                className="group block cursor-pointer"
              >
                <div className="relative aspect-[3/4] rounded-lg overflow-hidden mb-3 bg-background-200">
                  <img
                    src={movie.cover}
                    alt={movie.title}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute top-2 left-2 flex flex-wrap gap-1.5">
                    {movie.isHot && (
                      <span className="px-2 py-0.5 text-xs bg-primary-500 text-background-50 rounded-md whitespace-nowrap">
                        热播
                      </span>
                    )}
                    {movie.isNew && (
                      <span className="px-2 py-0.5 text-xs bg-accent-500 text-background-50 rounded-md whitespace-nowrap">
                        新上
                      </span>
                    )}
                    {movie.rating > 0 && (
                      <span className="px-2 py-0.5 text-xs bg-background-950/70 text-accent-300 rounded-md whitespace-nowrap">
                        {movie.rating}
                      </span>
                    )}
                  </div>
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-background-950/80 to-transparent p-3">
                    <p className="text-xs text-background-200 whitespace-nowrap">
                      {movie.updateInfo}
                    </p>
                  </div>
                </div>
                <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors duration-200 line-clamp-1">
                  {movie.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-1 line-clamp-1">
                  {movie.actors.slice(0, 3).join(" / ")}
                </p>
              </Link>
            ))}
          </div>

          {movies.length === 0 && (
            <div className="text-center py-20">
              <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4 rounded-full bg-background-100 text-foreground-400">
                <i className="ri-movie-2-line text-2xl"></i>
              </div>
              <p className="text-foreground-500">暂无内容</p>
            </div>
          )}
        </div>
      </section>
    </>
  );
}